export function resolveResultLink(backupId, item) {
    switch (item.kind) {
        case "mail":
            return `/backups/${backupId}/mail/${item.id}`;
        case "drive":
            return `/backups/${backupId}/drive/files/${item.id}`;
        case "calendar":
            return `/backups/${backupId}/calendar`;
        case "contact":
            return `/backups/${backupId}/contacts`;
    }
}
